/** True on Apple keyboards, iPad included. Lives here so `.tsx` files export components only. */
export const IS_MAC =
  typeof navigator !== 'undefined' &&
  /mac|iphone|ipad|ipod/i.test(navigator.platform || navigator.userAgent)
